import _default from './Ref';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Ref/index.js
// module id = 184
// module chunks = 1